import React from 'react';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody, MDBInput, MDBIcon } from 'mdbreact';
import { Redirect } from 'react-router-dom';
import DataLayer from '../Utilities/DataLayer';
import SocialLink from '../Components/ComponentFragments/SocialLink';


export default class Login extends React.Component {

    constructor(props) {
        super();
        this.state = {
            loginSuccess: false,
            mobiVersion: global.appVersion
        }

        this.SubmitLogin = this.SubmitLogin.bind(this);
        this.forgotPinClick = this.forgotPinClick.bind(this);
    }

    async SubmitLogin(event) {
        event.preventDefault();
        let dataLayer = new DataLayer();
        let loginObject = {"IsPWA":1, "SMSQueryCell": event.target.elements.SMSQueryCell.value, "MobiPass": event.target.elements.MobiPass.value };
        let loginSuccess = await dataLayer.Login(loginObject);
        const { history } = this.props;

        if (loginSuccess) {
            var TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
            //alert("Terms Accepted " + TMAUser.data.acceptedTerms)
            if (TMAUser.data.acceptedTerms) {
                history.push('/salesforce');
            } else {
                history.push('/termsandconditions');
            }
        }
    }

    forgotPinClick() {
        const { history } = this.props;
        history.push('/forgotpin');
    }

    render() {
        return (
            <MDBContainer>
                <MDBCard className="mt-5">
                    <MDBCardBody>
                    <MDBRow>
                        <MDBCol>
                                <span style={{ fontSize: "12px", color:"#666a6e", textDecoration:"underline"}}>Mobi Version: {this.state.mobiVersion}</span>
                            </MDBCol>
                    </MDBRow>
                    <div className="text-center pt-5">
                        <img style={{width: "163px"}} src={require('../Assets/Images/TWlogo2024.png')} />

                        <h1 style={{fontSize: "65px", color: "#7BD6DC"}} >MOBI</h1>
                        <p style={{fontSize: "18px"}}>Sales Force Website</p>
                    </div>
                    
                        <form className="mt-5" onSubmit={this.SubmitLogin}>
                            <MDBInput label="Cell Phone Number / User Name" type="text" name="SMSQueryCell" />
                            <MDBInput label="PIN / Password" type="password" name="MobiPass" />
                            <MDBRow>
                                <MDBCol>
                                    <MDBBtn type="submit" style={{backgroundColor: "#7BD6DC"}}>Login</MDBBtn>
                                </MDBCol>
                                <MDBCol style={{textAlign: 'right'}}>
                                    <MDBBtn onClick={this.forgotPinClick }>Forgot Pin?</MDBBtn>
                                </MDBCol>
                            </MDBRow>
                        </form>
                    </MDBCardBody>
                </MDBCard>

                <SocialLink />
            </MDBContainer>
        );
    }
}